import React from 'react';

import { HStack, SimpleGrid } from '@chakra-ui/react';

import { LazySvg } from '../LazySvg/LazySvg';
import { Markdown } from '../Markdown/Markdown';

const columns = new Map([
	[1, 1],
	[2, { base: 1, lg: 2 }],
	[3, { base: 1, lg: 2, '2xl': 3 }],
]);

export const Grid = ({ items, maxColumns, ...rest }) => {
	return (
		<SimpleGrid
			columns={columns.get(maxColumns)}
			spacingX={{ lg: 12, '2xl': maxColumns === 3 ? 24 : 40 }}
			spacingY={maxColumns === 1 ? 3 : { base: 3, sm: 5, lg: 8, '2xl': maxColumns === 3 ? 12 : 16 }}
			{...rest}
		>
			{items.map((item, idx) => (
				<HStack key={idx} spacing={3} alignItems="start">
					<LazySvg
						name={item.icon}
						mt={1}
						width={8}
						height={8}
						color={item.icon.includes('check') ? 'green.500' : 'primary.500'}
						flexShrink={0}
						transform={`rotate(${item.iconRotation}deg)`}
					/>
					<Markdown fontSize="xl" content={item.text} color="secondary.700" />
				</HStack>
			))}
		</SimpleGrid>
	);
};
